import { render, staticRenderFns } from "./productPriceCell.vue?vue&type=template&id=0b6558f8&scoped=true&"
import script from "./productPriceCell.vue?vue&type=script&lang=js&"
export * from "./productPriceCell.vue?vue&type=script&lang=js&"
import style0 from "./productPriceCell.vue?vue&type=style&index=0&id=0b6558f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6558f8",
  null
  
)

export default component.exports